import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { VoceCorrelataClassificaDTO } from "@app/shared/dto/voce-correlata-classificaDTO";
import { VoceCorrelataClassificaVO } from "@app/shared/vo/voce-correlata-classificaVO";
import { WrapperCollegamentoUnitaDocumentariaDTO } from "../dto/wrapper-collegamento-unita-documentariaDTO";
import { WrapperCollegamentoUnitaDocumentariaVO } from "../vo/wrapper-collegamento-unita-documentariaVO";
import { MapperClassifica } from "./mapper-classifica";
import { MapperUtente } from "./mapper-utente";
import { MapperVoceClassifica } from "./mapper-voce-classifica";
import { MapperVoceCorrelataClassifica } from "./mapper-voce-correlata-classifica";
import { MapperVisibilitaFascicolo } from "./mapper-visibilita-fascicolo";
import { MapperRiferimentiPosizione } from "./mapper-riferimenti-posizione";
import { MapperDocumento } from "./mapper-documento";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";

@Injectable({
  providedIn: "root",
})
export class MapperWrapperCollegamentoUD
  implements
    MapperInterface<
      WrapperCollegamentoUnitaDocumentariaDTO,
      WrapperCollegamentoUnitaDocumentariaVO
    > {
  constructor(
    private mapperClassifica: MapperClassifica,
    private mapperUtente: MapperUtente,
    private mapperVisibilitaElemento: MapperVisibilitaFascicolo,
    private mapperRiferimentoPosizione: MapperRiferimentiPosizione,
    private mapperDocumento: MapperDocumento,
    private mapperMetadatiRepertorio: MapperMetadatiRepertorio
  ) {}

  convertVoToDto(
    vo: WrapperCollegamentoUnitaDocumentariaVO
  ): WrapperCollegamentoUnitaDocumentariaDTO {
    if (vo != null) {
      const dto = new WrapperCollegamentoUnitaDocumentariaDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.id = vo.id;
      dto.classifica = this.mapperClassifica.convertVoToDto(vo.classifica);
      dto.dataUltimaModifica = vo.dataUltimaModifica;
      dto.inseritoDa = dto.inseritoDa = this.mapperUtente.convertVoToDto(
        vo.inseritoDa
      );
      dto.oggetto = vo.oggetto;
      dto.segnaturaArchivistica = vo.segnaturaArchivistica;
      dto.stato = vo.stato;
      dto.visibilitaElemento = this.mapperVisibilitaElemento.convertListVoToDto(
        vo.visibilitaElemento
      );
      dto.tipo = vo.tipo;
      dto.riferimentoPosizione = this.mapperRiferimentoPosizione.convertVoToDto(
        vo.riferimentoPosizione
      );
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(
    dto: WrapperCollegamentoUnitaDocumentariaDTO
  ): WrapperCollegamentoUnitaDocumentariaVO {
    if (dto != null) {
      const vo = new WrapperCollegamentoUnitaDocumentariaVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.id = dto.id;
      vo.primario = this.mapperDocumento.convertDtoToVo(dto.primario);
      vo.classifica = this.mapperClassifica.convertDtoToVo(dto.classifica);
      vo.dataUltimaModifica = dto.dataUltimaModifica;
      vo.inseritoDa = this.mapperUtente.convertDtoToVo(dto.inseritoDa);
      vo.oggetto = dto.oggetto;
      vo.dataInserimento = dto.dataInserimento;
      vo.segnaturaArchivistica = dto.segnaturaArchivistica;
      vo.visibilitaElemento = this.mapperVisibilitaElemento.convertListDtoToVo(
        dto.visibilitaElemento
      );

      if (dto.stato == "IN_LAVORAZIONE") {
        vo.stato = "IN LAVORAZIONE";
      } else {
        vo.stato = dto.stato;
      }
      vo.tipo = dto.tipo;
      vo.metadatiRepertorio = this.mapperMetadatiRepertorio.convertDtoToVo(
        dto.metadatiRepertorio
      );
      vo.riferimentoPosizione = this.mapperRiferimentoPosizione.convertDtoToVo(
        dto.riferimentoPosizione
      );
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: WrapperCollegamentoUnitaDocumentariaVO[]
  ): WrapperCollegamentoUnitaDocumentariaDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: WrapperCollegamentoUnitaDocumentariaDTO[]
  ): WrapperCollegamentoUnitaDocumentariaVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
